function SocketsPlatformVersionsCtrl($scope, $filter, GeneralUtilsService){
	$scope.datamodified = false;
	$scope.socketVersion = {};
	$scope.socketVersionHideLatest = true;
	$scope.ready = false;

    /**
	 * get all the socket build platforms
	 * after getting all build platforms we can init the table
     */
    store.fetch({
        path: "/getSocketBuildPlatforms",
        success: function(data){
            $scope.socketBuildPlatforms = data;
            init();
        }
    });

    store.fetch({
        path: "/getAutoUpgradesStatus",
        success: function(data){
            $scope.autoUpgrades = data;
        }
    });

    /**
	 * setting the table fields holding the socket platform versions
     * @returns {[*]}
     */
    function getTableFields() {
        var tableFields = [{"label": "Version", "path":"version", "template":"<span>{{item.version}}</span>"}];

        $scope.socketBuildPlatforms.sort().forEach(function(socketBuildPlatform){
            tableFields.push({"label": $filter('capitalize')(socketBuildPlatform), noSort: true,
				"template":"<div class='checkbox form-checkbox'><label><b ng-if=\"!item['"+socketBuildPlatform+"_fileExists']\" class='red'>!</b><input type='checkbox' ng-model='item.releasePlatformsObject." + socketBuildPlatform + "' ng-disabled=\"!item['"+socketBuildPlatform+"_fileExists'] && !item.releasePlatformsObject." + socketBuildPlatform + "\"></label></div>"})
        });

        tableFields.push(
            {"label": "Min. Version", "path":"minVersion", "template":"<input ng-model='item.minVersion' style='width:70px'>"},
            {"label": "EOL", "path": "EOL", "template": "<div class='checkbox form-checkbox'><label><input type='checkbox' ng-model='item.EOL'></label></div>"},
            {"label": "RN", "path": "releaseNotes", "template": "<textarea ng-model='item.releaseNotes'></textarea>"},
            {"label": "Description", "path": "description", "template": "<textarea ng-model='item.description'></textarea>"}
        );

        return tableFields;
    }


	function init(){
		$scope.ready = true;

		$scope.$root.hasChanges = function(){
			if($scope.srcItems){
				for(var i = 0;$scope.srcItems[i];i++){
					if(!angular.equals($scope.tableConfig.items[i], $scope.srcItems[i])){
						return true;
					}
				}
			}
			return false;
		};

		$scope.tableConfig = {
			id: 'socketVersions',
			dataURL : function() {
				return "/ag/getSocketVersions";
			},
			processData: function(items){
				$scope.items = $scope.parseBuildPlatform(items);
				$scope.srcItems =_.cloneDeep($scope.items);
				return $scope.items;
			},
			fields :  getTableFields(),
			type : "SocketVersion",
			pageSize: 10,
			addAction: function(){
				$scope.newVersion = {id:GeneralUtilsService.getRandomId(), "name": ""};
				$scope.$root.openPopup('addVersionDlg');
			},
			actions: ["remove"],
			editTable: true,
			titleSearch: "Versions",
			sortField: "version",
			sortDir: "DESC",
			hasChanges: function(){
				return $scope.$root.hasChanges();
			}
		};
	}

    /**
	 * function for adding a new version to the screen on the
	 * table
     */
	$scope.addVersion = function(){
		var params = {'type': 'SocketVersion', 'save': true};
		$scope.newVersion.fileName = $scope.socketVersion.version.fileName;
		$scope.newVersion.releasePlatforms = [];

		// adding via the dedicated route
		store.save({
			path: "/add",
			data: $scope.newVersion,
			dataObj: 'json',
			queryParams: params,
			success: function(data) {
				$scope.$root.handleServerResponse(data, "version", "Socket version added successfully");
				if(data.status !== "ERROR"){
					$scope.tableConfig.selectedId = data.model.id;
					$scope.datamodified = new Date().getTime();
					$scope.$root.closePopup('addSocketVersionConfirmation');
				}
			}
		});
	};

    /**
	 * method for saving the changes made on the
	 * table
     */
    $scope.saveChanges = function(){
        $scope.loading = true;

        var itemsToSave = angular.copy($scope.tableConfig.items);
        itemsToSave.forEach(function(item){
            item.newSaveMethod = true;
            if(item.releasePlatformsObject){
                item.releasePlatforms = [];
                item.releasePlatformsRaw= '';
                for(var rlsPltformKey in item.releasePlatformsObject){
                    if(item.releasePlatformsObject[rlsPltformKey]){
                    	if(!item.releasePlatformsRaw){
                            item.releasePlatformsRaw = rlsPltformKey;
						}
						else{
                            item.releasePlatformsRaw =item.releasePlatformsRaw +','+rlsPltformKey;
						}
                    }
                }
                delete item.releasePlatformsObject;
            }
        });

        store.save({
            path: "/ag/saveSocketVersions",
            data: itemsToSave,
            dataObj: 'json',
            queryParams: {
            },
            success: function(data){
                $scope.$root.handleServerResponse(data, "" , 'Versions changes were saved successfully');
                if(data.data && data.data.items){
                    $scope.datamodified = new Date().getTime();
                }
				$scope.closePopup('changeVersionsConfirmation');
				$scope.loading = false;
            }
        })
    };


    /**
	 * this method for parsing the build platforms getting the ones
	 *
     * @param items
     * @returns {*}
     */
	$scope.parseBuildPlatform = function (items) {
        if(items && items.length > 0){
            items.forEach(function(item){
                if(item.releasePlatforms){
                    item.releasePlatformsObject = {};

                    item.releasePlatforms.forEach(function(platformObj){
                        item.releasePlatformsObject[platformObj.platform] = true;
                    });
                }
            });
        }
        return items;
    };


	$scope.toggleAutoUpgrades = function(){
		store.save({
			path: "/toggleAutoUpgrades",
			success: function(data){
				$scope.$root.handleServerResponse(data, "" , 'Successfully set auto upgrades to ' + data);
				$scope.autoUpgrades = !data;
				$scope.$root.closePopup('changeAutoUpgradesConfirmation');
			}
		})
	};
}